export enum AutoSaveFeedbackStatusEnum {
    NONE = 'NONE',
    UNSAVED_CHANGES = 'UNSAVED_CHANGES',
    BUSY = 'BUSY',
    FAILED = 'FAILED',
    SUCCESS = 'SUCCESS',
}
